import {SYSTEM_MEASURE} from '../util/SystemMeasure';

export default class DashboardFrameData {

  postedSpeed = {
    value: '--',
    present: false,
    excessive: false,
    over: false
  }

  engineSpeed = {
    value: '--',
    present: false,
    needlePosition: 0
  }

  rpm = {
    speed: '--',
    present: false,
    needlePosition: 0
  }

  gpsSpeed = {
    value: '--',
    present: false
  }

  acceleration = {
    value: '--',
    unit: '',
    present: false,
    width: 0
  }

  forwardDistance = {
    value: '--',
    unit: '',
    present: false,
    width: 0
  }

  forwardSpeed = {
    value: '--',
    unit: '',
    present: false,
    width: 0
  }

  brakeOn = false
  clutchOn = false
  cruiseActive = false
  turnLightControl = 0

  constructor(systemMeasure, notAvailableSymbol = '--') {
    this.systemMeasure = systemMeasure;
    this.postedSpeed.value = notAvailableSymbol;
    this.engineSpeed.value = notAvailableSymbol;
    this.rpm.value = notAvailableSymbol;
    this.gpsSpeed.value = notAvailableSymbol;
    this.acceleration.value = notAvailableSymbol;
    this.forwardSpeed.value = notAvailableSymbol;
    this.forwardDistance.value = notAvailableSymbol;
  }

  setSpeedLimit(speedLimit, currentSpeed, {excessiveOverSpeed, overSpeed}) {
    if (!speedLimit) {
      return;
    }

    const roundedSpeedLimit = Math.round(speedLimit);
    const roundedCurrentSpeed = Math.round(currentSpeed || 0);

    const currentOverSpeed = roundedCurrentSpeed - roundedSpeedLimit;

    if (currentOverSpeed >= excessiveOverSpeed) {
      this.postedSpeed.excessive = true;
    } else if (currentOverSpeed >= overSpeed) {
      this.postedSpeed.over = true;
    }

    this.postedSpeed.present = true;
    this.postedSpeed.value = roundedSpeedLimit;
  }

  setEngineSpeed(speed) {
    this.engineSpeed.value = Math.round(speed);
    this.engineSpeed.present = true;
    this.engineSpeed.needlePosition = this.systemMeasure === SYSTEM_MEASURE.METRIC ? speed : speed * 1.5;
  }

  setRpm(rpm) {
    this.rpm.value = rpm;
    this.rpm.present = true;
    this.rpm.needlePosition = rpm * 0.036;
  }

  setGpsSpeed(gpsSpeed) {
    this.gpsSpeed.value = Math.round(gpsSpeed);
    this.gpsSpeed.present = true;
  }

  setAcceleration(acceleration) {
    let accelerationPercent = parseFloat(acceleration.toFixed(2));

    if (accelerationPercent > 100) {
      accelerationPercent = 100;
    }

    this.acceleration.value = accelerationPercent;
    this.acceleration.unit = ' %';
    this.acceleration.present = true;
    this.acceleration.width = ((acceleration * 140) / 100);
  }

  setForwardDistance(forwardDistance, forwardDistancePercent) {
    this.forwardDistance.value = forwardDistance;
    this.forwardDistance.percent = forwardDistancePercent;
    this.forwardDistance.unit = 's';
    this.forwardDistance.present = true;
    this.forwardDistance.width = ((forwardDistancePercent * 140) / 100);
  }

  setForwardSpeed(forwardSpeed, forwardSpeedPercent) {
    this.forwardSpeed.percent = forwardSpeedPercent;
    this.forwardSpeed.present = true;
    this.forwardSpeed.value = forwardSpeed;

    const shouldUseMetricSystem = this.systemMeasure === SYSTEM_MEASURE.METRIC;
    if (shouldUseMetricSystem) {
      this.forwardSpeed.unit = ' KM/H';
      this.forwardSpeed.width = ((forwardSpeed * 100) / 180);
    } else {
      this.forwardSpeed.unit = ' MPH';
      this.forwardSpeed.width = ((forwardSpeed * 100) / 120);
    }
  }

  setBrakeOn(brakeOn) {
    this.brakeOn = (brakeOn === true || brakeOn === 'ON');
  }

  setClutchOn(clutchOn) {
    this.clutchOn = (clutchOn === true || clutchOn === 'ON');
  }

  setCruiseActive(cruiseActive) {
    this.cruiseActive = (cruiseActive === true || cruiseActive === 'ACTIVE');
  }
}
